import type { ServiceIntervalConfig, ServiceLifeStatus } from '../../types';
import { getWearPercent } from '../getWearPercent';

const FULL_LIFE_PERCENT = 100;

// Remaining service-life percent = 100 - wear%, clamped to [0, 100].
// Reuses the existing wear computation so usage/wear stays the source of truth.
export const getServiceLifeRemaining = ({
    interval,
    usage
}: {
    interval?: ServiceIntervalConfig;
    usage: number;
}): ServiceLifeStatus => {
    const wearStatus = getWearPercent({ interval, usage });

    if (!wearStatus.configured) {
        return { configured: false };
    }

    const remaining = Math.min(
        FULL_LIFE_PERCENT,
        Math.max(0, FULL_LIFE_PERCENT - wearStatus.percentage)
    );

    return { configured: true, remaining };
};
